module.exports = __webpack_public_path__ + "fonts/f95f9fc2-ffda-431c-9d6a-2c3668f5b20b.13e4fce.eot";